
/* injects from baggage-loader */


'use strict'

import { PlatesType } from '../../components/ui/types/plates';

import StageBaseController from '../stage-base.controller';

import { balloons } from './stage-sixth.const';

import { balloons2 } from './stage-sixth.const';

import setaAnterior from '_images/stage-three/seta_anterior_audio_pedido.png';
import setaProximo from '_images/stage-three/seta_proximo_audio_pedido.png';
import play from '_images/stage-three/play_audio_pedido.png';
import pause from '_images/stage-three/pause_audio_pedido.png';

import _ from 'lodash/core';

import regions from '_appRoot/components/ui/tab-book/tab-book.const';

import html2canvas from 'html2canvas';

export default class StageSixthController extends StageBaseController{
    constructor($log, $rootScope, $state, $timeout, $interval, Dialog, Trophies, Session, TTS) {
        'ngInject';        
        super($log, $rootScope, $state, $timeout, Dialog, Trophies, Session, 'main.stage-sixth');

        this.$timeout = $timeout;

        this.TTS = TTS;
        this.nextRoute = 'main.stage-fifth';
        this.defaultLevel = 4;
        this.$interval = $interval;

        this.setaAnteriorImg = setaAnterior;
        this.setaProximoImg = setaProximo;
        this.playImg = play;
        this.pauseImg = pause;
        this.indexPlayPause = 0;

        this.btnPlayPause = [this.playImg,this.pauseImg];
        

        this.orderLabel = ["Entrada","Prato principal","Sobremesa","Bebida"];
        this.indexSpeak = 0;

        this.state = {
            region: 'chef',
            sequence: [
                PlatesType.entrance,
                PlatesType.entrance,
                PlatesType.principal,
                PlatesType.principal,
                PlatesType.principal,
                PlatesType.dessert,
                PlatesType.drink
            ]
        };

        this.balloons = {
            step: 0,
            steps: balloons
        };

        this.balloons2 = {
            step: 0,
            steps: balloons2
        };

        this.notListening = true;

        let newMenu = JSON.parse(JSON.stringify(regions['sudeste']));
       
        this.order = {
            entrance:[randomizeOrder(newMenu.tabs[0].items),randomizeOrder(newMenu.tabs[0].items)],
            principal:[randomizeOrder(newMenu.tabs[1].items),randomizeOrder(newMenu.tabs[1].items),randomizeOrder(newMenu.tabs[1].items)],
            dessert:randomizeOrder(newMenu.tabs[2].items),
            drink:randomizeOrder(newMenu.tabs[3].items)           
        };

        function randomizeOrder(orderType) {
            let size = orderType.length;
            let random = Math.floor(Math.random() * size);

            let plate = orderType[random];

            orderType.splice(random,1);

            return plate;

        }

        const e = '; e ;';
        const dot = '; , ;';
        let entradas = "O cliente pediu as entradas: "+this.order.entrance[0].title+e+this.order.entrance[1].title;
        let pratos = "O cliente pediu os pratos principais: "+this.order.principal[0].title+dot+this.order.principal[1].title+e+this.order.principal[2].title;
        let sobremesas = "O cliente pediu a sobremesa: "+this.order.dessert.title;
        let bebidas = "O cliente pediu a bebida: "+this.order.drink.title;

        this.clientOrder = [this.order.entrance[0].title,this.order.entrance[1].title,this.order.principal[0].title,this.order.principal[1].title,this.order.principal[2].title,this.order.dessert.title,this.order.drink.title];

        this.orderToSpeak = [entradas,pratos,sobremesas,bebidas];

        for(let i = 0; i < this.orderToSpeak.length; i++){
            this.orderToSpeak[i] = this.orderToSpeak[i].replace('<small>','');
            this.orderToSpeak[i] = this.orderToSpeak[i].replace('(pedaço)','');
            this.orderToSpeak[i] = this.orderToSpeak[i].replace('</small>','');
            this.orderToSpeak[i] = this.orderToSpeak[i].trim();
        }

        this.$rootScope.$on('setCurrentTab', (event, data) => { 
            
            this.indexSpeak = data;
            this.TTS.clear();
        });

        //textos

        this.nomeSet = false;

		this.title = {
			word:"Escreva o nome do restaurante aqui",
			editorEnabled:false,
			editableWord:"",
			placeholder: "Escreva o nome do restaurante aqui" 
        };

        this.words = [
			{word:"Escreva algo", editorEnabled:false, editableWord:"", placeholder: "Escreva algo"},
        ];
        
        this.$rootScope.$on('setListTitle', (event, data) => { 
            this.dataAux = data;
            this.nomeSet = true;
        });


        //recebendo informação pratos

        this.tabContent = {
            words: []
        }

        this.$rootScope.$on('setPratos', (event, data) => { 
            this.setTabContents(data[0], data[1]);
        });

        this.showOptions = false;

        this.$rootScope.$on('showOptions', (event, data) => { 
            this.showOptions = data;
        });

        //setando o cardapio

        this.cardapio = false;

        this.separador = "................................................................................................";

        this.selecionado = false;

        //baixando a img remotamente

        this.download = false;

        this.$rootScope.$on('downloadImg', (event, data) => { 
            if (data === true){
                this.toImgDownload();
            }
        });

        this.liberado = false;
    }

    $onInit(){
        super.$onInit();
    }

    openFail(){
        let msg = `O pedido não pôde ser confirmado.<br> Algum prato não foi registrado de forma correta.`;
        super.openFail(msg);
    }
    
    isValid(){
        let isValid = true;
                
        this.model.items.forEach((item, index) => {
            console.log(item);
            if(item.value) {
                if(!this.clientOrder.includes(item.value.title)){

                    isValid = false;
                }
                this.state.sequence[index] !== item.value.type ? isValid = false : null;
            } else {
                isValid = false;
            }
        });

        return isValid;
    }

    onSubmitOrder(){
        return this.isValid() ? this.openSuccess() : this.openFail();
    }    

    //tutoriais

    toNextBalloon(){
        this.balloons.step++;

        if(this.balloons.steps.length === this.balloons.step){
            this.liberado = true;
            this.$rootScope.$emit('start:countdown');
        }
    }

    toNextBalloon2(){
        this.balloons2.step++;

        if(this.balloons2.steps.length === this.balloons2.step){
            this.$rootScope.$emit('start2:countdown', true);
        }
    }

    //edição de texto

    enableEditor(w) {
		if(!this.print){
			w.editorEnabled = true;
			if(w.word === w.placeholder)
				w.editableWord = "";
			else
				w.editableWord = w.word;
		}
    }

	addItem() {
		if(this.words.length < 10)
			this.words.push({word: "Escreva algo", editorEnabled:false, editableWord:"", placeholder: "Escreva algo"});
    }
    
    nextTitle(w){
		if(w.editableWord !== ""){
			w.word = "Restaurante " + w.editableWord;
			if(this.words[0].word === this.words[0].placeholder){
                this.words[0].editorEnabled = true;
                this.$timeout(() => {
                    this.$rootScope.$emit('setListTitle',w.word);
                }, 4000);
            }
		} else {
			w.word = w.placeholder;
		}
        w.editorEnabled = false;
    }
    
    next(w, index){
		if(w.editableWord !== ""){
			if(_.isUndefined(this.words[index+1]))
                w.word = "Restaurante " + w.editableWord;
		} else {
			w.word = w.placeholder;
		}
		w.editorEnabled = false;
    }
    
    setTabContents(word, index){
        if (index % 2 === 0)
            this.tabContent.words[index] = word + this.separador;
        else
            this.tabContent.words[index] = word;
    }

    //selecionando o cardapio

    seleciona(event){
        let aux = event.currentTarget.attributes['data-id'].value;

        this.cardapio = aux;

        this.$timeout(() => {
            this.toggleView();
            this.openSuccess();
        }, 500);
        
    }

    //salvando a img

    toImg(){
        let ctx = document.querySelector("#cardapioCanvas");

        html2canvas(document.querySelector("#capture"), {allowTaint: true, canvas: ctx}).then(canvas => {
            canvas.toDataURL();
        });        
    }

    toImgDownload(){
        html2canvas(document.querySelector("#capture"), {allowTaint: true}).then(canvas => {
            this.saveAs(canvas.toDataURL(), 'cardapio.png');
        });
    }

    saveAs(uri, filename){
        let link = document.createElement('a');

        if (typeof link.download === 'string') {
            link.href = uri;
            link.download = filename;

            //Firefox requires the link to be in the body
            document.body.appendChild(link);

            //simulate click
            link.click();

            //remove the link when done
            document.body.removeChild(link);
        } else {
            window.open(uri);
        }
    }

    toggleView(){
        this.selecionado = !this.selecionado;
        
        if (this.selecionado){
            this.toImg();
        }
    }

    //mensagem

    openSuccess(){
        let msg = 'Parabéns! Você realizou todos os passos necessários para se tornar um Chef de sucesso!';
        let type = 'ok';

        this.Dialog.showFeedback(msg, type);
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/stage-sixth/stage-sixth.controller.js